import axios from "axios";
import router from "../router";
import Vue from "vue";
import store from "@/state/store";

export default (options = { daemonRequest: false }) => {
  const url = options.daemonRequest 
    ? process.env.VUE_APP_INTEGRATION_URL
    : process.env.VUE_APP_INTEGRATION_URL;

  const axiosInstance = axios.create({
    baseURL: `${url}/api`,
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
  });

  Vue.prototype.$http = axiosInstance;
  Vue.config.productionTip = false;
  axiosInstance.defaults.timeout = 1000000;

  

  axiosInstance.interceptors.request.use(
    async (config) => {
    //   const user = JSON.parse(localStorage.getItem("user"));
      const now = new Date();
    const tokenTime = JSON.parse(localStorage.getItem("Integration_Token_Time")) ?
     new Date(JSON.parse(localStorage.getItem("Integration_Token_Time"))) : ''; 
    if (tokenTime) {
      const msBetweenDates = Math.abs(tokenTime.getTime() - now.getTime());
      const hoursBetweenDates = msBetweenDates / (60 * 60 * 1000);
      // console.log('tokenTime mddl', tokenTime, now);
      // console.log('hoursBetweenDates mddl', hoursBetweenDates);
      if (hoursBetweenDates >= 24 ) {
         await store.dispatch("authfack/fetchClientSecret");
         await store.dispatch("authfack/fetchInterationToken");
      }
    } else {
      await store.dispatch("authfack/fetchClientSecret");
      await store.dispatch("authfack/fetchInterationToken");
    }
    const integration_token = JSON.parse(localStorage.getItem("Integration_Token"));
      // console.log('integration_token', integration_token);
      if (integration_token) {
        config.headers.common["Authorization"] = `Bearer ${integration_token}`;
      }
      return config;
    },
    (error) => {
      return Promise.reject(error);
    }
  );
  axiosInstance.interceptors.response.use(
    (response) => {
      if (response.status === 200 || response.status === 201) {
        return Promise.resolve(response.data);
      } else {
        return Promise.reject(response);
      }
    },
    (error) => {
      if (error&&error.response&&error.response.status) {
        switch (error.response.status) {
          case 400:
            //do something
            break;
          case 401:
            router.push("/error");
            break;
          case 403:
            break;
          case 404:
            router.push("/404");
            break;
          case 502:
            alert(error.response);
            alert("502 Server Erorr Please Call Administration : ",error.response);
            break;
            case 500:
            alert("500 Server Erorr Please Call Administration : ",error.response);
            break;
            default:
        }
        return Promise.reject(error.response);
      }
    }
  );
  return axiosInstance;
};
